// Operator primitives, per design/03_Rune_Language.md.

export type OperatorId = 'transfer' | 'convert' | 'bind' | 'separate' | 'measure' | 'project';

export interface OperatorDef {
  id: OperatorId;
  name: string;
  description: string;
  requiresSecondConcept: boolean;
  readOnly: boolean;
}

export const OPERATORS: Record<OperatorId, OperatorDef> = {
  transfer: {
    id: 'transfer',
    name: 'Transfer',
    description: 'Move a quantity between two loci, conserving the total.',
    requiresSecondConcept: false,
    readOnly: false,
  },
  convert: {
    id: 'convert',
    name: 'Convert',
    description: "Change a quantity's dimensional shape while respecting whatever conservation law wraps it.",
    requiresSecondConcept: true,
    readOnly: false,
  },
  bind: {
    id: 'bind',
    name: 'Bind',
    description: 'Couple two loci so a change to one propagates to the other. Structural, not a quantity transfer.',
    requiresSecondConcept: false,
    readOnly: false,
  },
  separate: {
    id: 'separate',
    name: 'Separate',
    description: 'Decouple two loci, or split matter along an internal boundary.',
    requiresSecondConcept: false,
    readOnly: false,
  },
  measure: {
    id: 'measure',
    name: 'Measure',
    description: 'Read a quantity without an intended transfer. Not necessarily free — see Landauer cost below.',
    requiresSecondConcept: false,
    readOnly: true,
  },
  project: {
    id: 'project',
    name: 'Project',
    description: 'Spread a quantity spatially from a source, or concentrate a distributed quantity to a point.',
    requiresSecondConcept: false,
    readOnly: false,
  },
};

export const OPERATOR_LIST: OperatorDef[] = Object.values(OPERATORS);
